export default "__VITE_ASSET__fb1e273a__"